export type EmailSubscriptionRequest = {
    email: string,
    template_type: EmailTemplateType,
    status?: EmailSubscriptionStatus
}

export enum EmailTemplateType {
    MONTHLY_STATS_EMAIL = "monthly_stats_email",
    LOW_SCANS_EMAIL = "low_scans_email",
    GENERIC_EMAIL = "generic_email",
    Monthly_Status_Executive = "monthly_status_executive_email",

    CALL_FINAL = "AccountCreatedFunnel/CallFinal",
    CALL_TO_CONVERT_1 = "AccountCreatedFunnel/CallToConvert1",
    RESULTS_UPDATE_1 = "AccountCreatedFunnel/ResultsUpdate1",
    WELCOME = "AccountCreatedFunnel/Welcome",

    SUBSCRIPTION_WELCOME = "SubscriptionFunnel/SubscriptionWelcome",
    SUBSCRIPTION_PRODUCT_UPDATE = "SubscriptionFunnel/SubscriptionProductUpdate",
    SUBSCRIPTION_FEEDBACK = "SubscriptionFunnel/SubscriptionFeedback",
    SUBSCRIPTION_CANCELLATION = "SubscriptionCancellation",
    SUBSCRIPTION_CANCELLATION_CONFIRMATION = "SubscriptionCancellationConfirmation",
    DataBrokerDirectResponse = "SubscriptionFunnel/DataBrokerDirectResponse",

    EMPLOYEE_UPDATE_1 = "CorporateFunnel/EmployeeUpdate1",
    EMPLOYEE_UPDATE_2 = "CorporateFunnel/EmployeeUpdate2",

    CORPORATE_INVITE_NEW_USER = "CorporateInviteNewUser",
    CORPORATE_INVITE_EXISTING_USER = "CorporateInviteExistingUser",
    CORPORATE_EXECUTIVE_INVITE_NEW_USER = "CorporateExecutiveInviteNewUser",
    FAMILY_INVITE_NEW_USER = "FamilyInviteNewUser",
    FAMILY_INVITE_EXISTING_USER = "FamilyInviteExistingUser",

    PORTAL_ADMIN_ONBOARDING = "PortalAdminOnboarding"
}
enum EmailSubscriptionStatus {
    SUBSCRIBED = "subscribed",
    UNSUBSCRIBED = "unsubscribed"
}
